import React from 'react';
import { IconBookmark, IconBookmarkFilled } from '@tabler/icons-react';

const BookmarkIcon = ({ filled = false, size = 20, color = '#001A47' }) => (
  <>
    {filled ? (
      <IconBookmarkFilled size={size} color={color} style={{ aspectRatio: '1/1' }} />
    ) : (
      <IconBookmark size={size} color={color} style={{ aspectRatio: '1/1' }} />
    )}
  </>
);

export default BookmarkIcon;
